export default "__VITE_ASSET__C28BDvP7__"